import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  containerOrders: {
    flex: 1,
    maxWidth: 340,
    minWidth: 320,
    height: "auto",
    paddingHorizontal: 25,
    paddingVertical: 25,
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },
  contentOrders: {
    flexDirection: "row",
  },
  titleOrdersAndTrade: {
    fontWeight: "bold",
    color: "#077A97",
    fontSize: 18,
    marginBottom: 6,
  },
  contentDescriptionOrders: {
    flexDirection: "row",
    gap: 55,
    paddingVertical: 5,
    justifyContent: "space-between",
    alignItems: "center",
  },
  textDescriptionsOrders: {
    fontSize: 12,
    width: "40%",
  },
  actionsOrders: {
    fontSize: 12,
    width: "20%",
  },
  pricePurchase: {
    fontSize: 12,
    color: "green",
  },
  priceSale: {
    fontSize: 12,
    color: "#B90000",
  },
  amountPurchase: {
    fontSize: 12,
  },
  amountSale: {
    fontSize: 12,
  },
  emptyOrders: {
    fontSize: 13,
    textAlign: "center",
  },
  errorTxtSemSaldo: {
    color: "#B90000",
    textTransform: "uppercase",
    fontWeight: "bold",
    textAlign: "center",
  },
  containerErro: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  orderPurchases: {
    fontSize: 12,
  },
  orderPurchasesBold: {
    fontSize: 12,
    fontWeight: "bold",
  },
  hr: {
    height: 2,
    marginTop: 10,
    backgroundColor: "#077A97",
    opacity: 0.3,
  },
  hr2: {
    height: 2,
    marginTop: 10,
    backgroundColor: "#077A97",
    opacity: 0.3,
    marginBottom: 10,
  },
  ordersTitle: {
    fontSize: 10,
    fontWeight: "300",
    textTransform: "uppercase",
    color: "#2C2C2E",
  },
  contentPurchaseOrSale: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 12,
  },
  actionButtonTxtComprar: {
    color: "#FFF",
    textTransform: "uppercase",
    fontWeight: "bold",
    textAlign: "center",
  },
  actionButtonVender: {
    textTransform: "uppercase",
    fontWeight: "bold",
    color: "#077A97",
    textAlign: "center",
  },

  actionButton: {
    color: "#FFFFFF",
    textAlign: "center",
  },
  noOrdersMessage: {
    textAlign: "center",
    fontSize: 14,
    color: "#888",
    marginTop: 20,
  },

  columnContainer: {
    flexDirection: "column",
    width: "100%",
    alignSelf: "center",
  },
  rowContainer: {
    alignSelf: "center",
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  btnCancelarOrdem: {
    minWidth: 114,
    marginTop: 12,
    backgroundColor: "#ec5353",
    alignSelf: "center",
    paddingVertical: 8,
    paddingHorizontal: 4,
    borderRadius: 4,
  },
});

export default styles;
